import React from 'react';
import {Polar} from 'react-chartjs-2';
// var Highcharts = require('highcharts');
import * as Highcharts from 'highcharts';
import './index.css';

var HighchartsMore = require('highcharts-more');
HighchartsMore(Highcharts);


// var operationAndDelivery = {
//   "labels": [
//     "Ownershi8p 2.92",
//     "Ownership 4.3",
//     "Aspiration 4.93",
//     "Optimization 3.97",
//     "Empowerment 3.71",
//     "Credibility 4.33",
//     "Influence 5.56",
//     "Urge to Learn 3.78",
//     "Initiative 4.32",
//     "Openness 6.68",
//     "Authenticity 4.29",
//     "Concern 5.69",
//     "Outspokenness 5.67",
//     "Responsibility 5.44",
//     "Acceptance 6.25",
//     "Expression 5.08"
//   ],
//   "data": [
//     {
//       "name": "Ownershi8p",
//       "color": "#5677c4",
//       "y": 2.92
//     },
//     {
//       "name": "Ownership",
//       "color": "#5677c4",
//       "y": 4.3
//     },
//     {
//       "name": "Aspiration",
//       "color": "#5677c4",
//       "y": 4.93
//     },
//     {
//       "name": "Optimization",
//       "color": "#5677c4",
//       "y": 3.97
//     },
//     {
//       "name": "Empowerment",
//       "color": "#c762b6",
//       "y": 3.71
//     },
//     {
//       "name": "Credibility",
//       "color": "#c762b6",
//       "y": 4.33
//     },
//     {
//       "name": "Influence",
//       "color": "#c762b6",
//       "y": 5.56
//     },
//     {
//       "name": "Urge to Learn",
//       "color": "#e69729",
//       "y": 3.78
//     },
//     {
//       "name": "Initiative",
//       "color": "#e69729",
//       "y": 4.32
//     },
//     {
//       "name": "Openness",
//       "color": "#e69729",
//       "y": 6.68
//     },
//     {
//       "name": "Authenticity",
//       "color": "#48b58a",
//       "y": 4.29
//     },
//     {
//       "name": "Concern",
//       "color": "#48b58a",
//       "y": 5.69
//     },
//     {
//       "name": "Outspokenness",
//       "color": "#48b58a",
//       "y": 5.67
//     },
//     {
//       "name": "Responsibility",
//       "color": "#fa7171",
//       "y": 5.44
//     },
//     {
//       "name": "Acceptance",
//       "color": "#fa7171",
//       "y": 6.25
//     },
//     {
//       "name": "Expression",
//       "color": "#fa7171",
//       "y": 5.08
//     }
//   ],
//   "min_avg_attribute": 2.92,
//   "max_avg_attribute": 6.68,
//   "min_attribute_index": 0,
//   "max_attribute_index": 9
//  }

class Radarcharts extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      graphData: props.graphData
    }
  }

  componentDidMount() {
      if(this.props.heading == 'DISCIPLINE') {
        this.barChart()
      }
      else {
        this.highCharts()
      }
    
  }

  barChart = () => {
    var barGraphData = this.dataParser();
    var chart = new Highcharts.chart('polarGraph', {
        chart: {
            height: 300,
            type: 'column',
            spacingBottom: 30,
        },
        exporting: {
            enabled: false
        },
        title: {
            text: ''
        },
        credits: {
            enabled: false
        },
        xAxis: {
            categories: barGraphData.labels,
            labels: {
                style: {
                    fontSize: '10px'
                }
            },
        },
        yAxis: {
            tickInterval: 2,
            enabled: false,
            max: 10,
            min: 0,
            title: {
                enabled: false,
            },
            labels: {
                style: {
                    fontSize: '10px'
                }
            }
        },
        plotOptions: {
            // series: {
            //     pointPadding: 0,
            //     groupPadding: 0,
            // },
            column: {
                pointPadding: 0.2,

                borderWidth: 0,
                dataLabels: {
                     y: 12,
                    enabled: true,
                    style: {
                        fontSize: '10px'
                    }
                },

            }
        },
        series: [{
            showInLegend: false,
            data: barGraphData.data,
            formatter: function () {
                return Highcharts.numberFormat(this.y, '.2f');
            }
        }]
    })
  }

  highCharts = () => {
    var operationAndDelivery = this.dataParser();
    var chart = new Highcharts.Chart({
      chart: {
          renderTo: document.getElementById('polarGraph'),
          polar: true,
          type: 'column',
          backgroundColor: '#f3f3f3'
      },
      exporting: {
          enabled: false
      },
      title: {
          text: '',
      },
      pane: {
          size: window.innerWidth > 1200 ? window.innerWidth > 1300 ? '75%' : '60%' : '50%'
      },
      xAxis: {
          categories: operationAndDelivery.labels,
          align: 'center',
          // tickmarkPlacement: 'on',
          gridLineWidth: 1,
          tickWidth: 1,
          plotLines: [{ 
              color: 'red',
              width: 1,
              value: operationAndDelivery.min_attribute_index,
              dashStyle: 'dash',
              className: 'plotline-1 fill-red',
              label: {
                  style: {
                      verticalAlign: 'middle',
                      textAlign: 'center'
                  }
              }
          },{ 
              color: 'green',
              width: 1,
              value: operationAndDelivery.max_attribute_index,
              dashStyle: 'dash',
              className: 'plotline-1 fill-green',
              label: {
                  style: {
                      verticalAlign: 'middle',
                      textAlign: 'center',
                      // marker-end: url(#arrow);
                  }
              }
          }],
          
          labels: {
              overflow: 'allow',
              style: {
                  fontSize: '10px'
              }
          },
      },
      credits: {
        enabled: false
      },
      yAxis: {
          tickInterval: 2,
          lineWidth: 1,
          tickWidth: 5,
          min: 0,
          max: 10,
          labels: {
              style: {
                  fontSize: '10px'
              }
          },
          plotLines: [{
              color: '#585858',
              width: 2,
              value: operationAndDelivery.min_avg_attribute,
              zIndex: 5,
              dashStyle: 'dashdot'
          }, {
              color: '#585858',
              width: 2,
              value: operationAndDelivery.max_avg_attribute,
              zIndex: 5,
              dashStyle: 'dashdot',
          }]
      },
      plotOptions: {
          column: {
              size: 40,
              borderWidth: 1,
              pointPadding: 0,
              groupPadding: 0,
          }
      },
      legend: {
          layout: 'vertical'
      },
      series: [{
          type: 'column',
          name: '',
          // color: operationAndDelivery.color, // color: 'rgb(245, 99, 78)' , // data: [8, 7, 6, 9, 4], 
          // data: polarGraphData[i].score,
          // pointPlacement: 'between',
          data: operationAndDelivery.data,
          showInLegend: false
      }],
      tooltip: {
        enabled: true,
        formatter: function () {
            return this.key + ' : ' + Highcharts.numberFormat(this.y, '.2f');
        }
      },
      defs: {
          marker0: {
              tagName: 'marker',
              render: true, // if false it does not render the element to the dom
              id: 'arrow',
              children: [{
                  tagName: 'path',
                  d: 'M0,0 L0,6 L9,3 z',
                  // fill: '#f00'
              }],
              markerWidth: 10,
              markerHeight: 10,
              refX: 9,
              refY: 3,
              orient: 'auto',
              markerUnits:"strokeWidth",
              viewBox:"0 0 20 20"
          },
      }
  });
  }

  colorPrser = (attribute) => {

    var orientationLvlColor = {
        "Aspiration": '#5577c4',
        "Ownership": '#ef706f',
        "Optimization":"#50b58a",
        "Involvement": "#c761b6",
        "Planning": "#e6973b",
        "Time sense": "#8ecf4c",
        "Expression": "#5577c4",
        "Acceptance": "#ef706f",
        "Responsibility": "#50b58a",
        "Sensitivity": "#c761b6",
        "Appropriateness": "#e6973b",
        "Influence": "#5577c4",
        "Empowerment": "#ef706f",
        "Credibility": "#50b58a",
        "Task Involvement": "#c761b6",
        "People Involvement": "#e6973b",
        "Organized": "#8ecf4c",
        "Prioritization": "#8b5758",
        "Urge to Learn": "#5577c4",
        "Openness": "#ef706f",
        "Initiative": "#50b58a",
        "Understanding": "#c761b6",
        "Integration": "#e6973b",
        "Structured": "#8ecf4c",
        "Time for Learning": "#8b5758",
        "Outspokenness": "#5577c4",
        "Concern": "#ef706f",
        "Authenticity": "#50b58a",
        "Conviction": "#c761b6",
        "Context Sensitivity": "#e6973b"
    }

    var orientaionColorsDefault = {
        "achievement": "#215bab",
        "relationship": "#e6384c",
        "leadership": "#a83282",
        "learning": "#ef7f3a",
        "nurturing": "#449847"
    }

    var color = {
        "Authenticity": "rgb(0, 166, 89)",
        "Concern": "rgb(0, 166, 89)" ,
        "Outspokenness": "rgb(0, 166, 89)",
        "Aspiration":"rgb(40, 94, 171)",
        "Ownership":"rgb(40, 94, 171)",
        "Optimization":"rgb(40, 94, 171)",
        "Expression": "rgb(227, 18, 69)",
        "Acceptance": "rgb(227, 18, 69)",
        "Responsibility": "rgb(227, 18, 69)",
        "Influence": "rgb(173, 29, 162)",
        "Empowerment": "rgb(173, 29, 162)",
        "Credibility": "rgb(173, 29, 162)",
        "Initiative":"rgb(241, 126, 0)",
        "Openness":"rgb(241, 126, 0)",
        "Urge to Learn" :"rgb(241, 126, 0)",
        "Involvement": "rgb(40, 94, 171)",
        "Sensitivity": "rgb(227, 18, 69)",
        "Task Involvement": "rgb(173, 29, 162)",
        "People Involvement" : "rgb(173, 29, 162)",
        "Understanding ":"rgb(241, 126, 0)",
        "Integration":"rgb(241, 126, 0)",
        "Conviction":"rgb(0, 166, 89)",
        "Time sense":"rgb(142, 207, 76)",
    }
    if(this.props.orientationLvl) {
        for (var key in orientationLvlColor) {
            if (orientationLvlColor.hasOwnProperty(key)) {
                if(key == attribute) {
                    return `${orientationLvlColor[key]}`
                }
            }
        }
    }else {
        for (var key in color) {
            if (color.hasOwnProperty(key)) {
                if(key == attribute) {
                    return `${color[key]}`
                }
            }
        }
    }

    for (const key in orientaionColorsDefault) {
        if (orientaionColorsDefault.hasOwnProperty(key)) {
            const element = orientaionColorsDefault[key];
            if(this.props.graphData.orientation_name) {
                if(key === this.props.graphData.orientation_name.toLowerCase()) {
                    return `${element}`
                }
            }
        }
    }

  }

  dataParser = () => {
    
    var lable = [];
    var data = [];
    var score = [];
    this.props.graphData.graph_data.map((obj) => {
        score.push(obj.average_score)
      lable.push(obj.attribute_name + ' ' + obj.average_score.toFixed(2))
    //   var letters = '0123456789ABCDEF';
    //   var color = '#';
    //   for (var i = 0; i < 6; i++) {
    //     color += letters[Math.floor(Math.random() * 16)];
    //   }
      data.push({
        "name": `${obj.attribute_name}`,
        "color": this.colorPrser(`${obj.attribute_name}`),
        "y": obj.average_score
      })
    })
    var final_data = {
      "labels" : lable,
      "data": data,
      "min_avg_attribute": Math.min(...score),
      "max_avg_attribute": Math.max(...score),
    }
    
    return final_data
  }
    render() {
      
        return (
          <div className="h-87" id="polarGraph">

            {/* <Polar data={this.dataParser()} height={200}/> */}
          </div>
        );
    }
}

export default Radarcharts




// WEBPACK FOOTER //
// ./src/_components/common/Charts/RadarCharts/index.js